/**
 * Events - A basic Javascript (publish subscribe) pattern , also know as (mediator pattern)
 * Preparing for scalability, in case if more filter types are needed
 */
const PubSubEvents = {
    events: {},
    subscribe: function (eventName, fn) {
        this.events[eventName] = this.events[eventName] || []
        this.events[eventName].push(fn)
    },
    unSubscribe: function (eventName, fn) {
        if (this.events[eventName]) {
            for (var i = 0; i < this.events[eventName].length; i++) {
                if (this.events[eventName][i] === fn) {
                    this.events[eventName].splice(i, 1)
                    break
                }
            }
        }
    },
    publish: function (eventName, data) {
        if (this.events[eventName]) {
            this.events[eventName].forEach(function (fn) {
                fn(data)
            })
        }
    },
}

/**
 * DownloadsFilter
 *
 */
export class DownloadsFilter {
    constructor() {
        this.downloadFilterNavigation = document.querySelector('.js__download__filter-navigation')
        this.downloadElements = document.querySelectorAll('.js__download')

        if (this.downloadFilterNavigation) {
            this.init()
        }

        PubSubEvents.subscribe('DownloadCagegoryFilterChanged', this.updateCategoryDownloadElements.bind(this))
    }

    /**
     * init
     *
     * @returns {undefined}
     */
    init() {
        this.downloadFilterNavigation.onclick = (event) => {
            if (event.target.classList.contains('js__download__filter-navigation-item--reset')) {
                this.showAll()
            }

            if (event.target.classList.contains('js__download__filter-navigation-item')) {
                var clickedTarget = event.target
                clickedTarget.classList.toggle('js__filter--is-active')

                // loop though all child items
                var items = this.downloadFilterNavigation.querySelectorAll('.js__download__filter-navigation-item')

                var data = {}
                data['categories'] = []

                items.forEach(function (item) {
                    if (item.classList.contains('js__filter--is-active')) {
                        data['categories'].push(item.dataset.filterCategory)
                    }
                })

                PubSubEvents.publish('DownloadCagegoryFilterChanged', data)
            }
        }
    }

    /**
     * updateCategoryDownloadElements
     * @param data {object}
     * @returns {undefined}
     */
    updateCategoryDownloadElements(data) {
        this.deactivateResetButtonStyle()
        var categories = data.categories

        if (categories.length >= 1) {
            var itemsToShow = []
            // preparing indexes for setting css class
            this.downloadElements.forEach((element, index) => {
                categories.forEach((category) => {
                    if (element.dataset.filterCategory === category) {
                        if (itemsToShow[index] === undefined) {
                            itemsToShow[index] = true
                        }
                    }
                })
            })

            // Set css class
            this.downloadElements.forEach((element, index) => {
                if (itemsToShow[index] === true) {
                    element.classList.add('js__is-visible')
                    element.classList.remove('js__is-not-visible')
                } else {
                    element.classList.add('js__is-not-visible')
                    element.classList.remove('js__is-visible')
                }
            })
        } else {
            this.showAll()
        }
    }

    /**
     * showAll Elememnts
     * @returns {undefined}
     */
    showAll() {
        this.downloadElements.forEach((element) => {
            element.classList.add('js__is-visible')
            element.classList.remove('js__is-not-visible')
        })

        this.resetFilterNavigation()
        this.activateResetButtonStyle()
    }

    /**
     * resetFilterNavigation
     * @returns {undefined}
     */
    resetFilterNavigation() {
        var items = this.downloadFilterNavigation.querySelectorAll('.js__download__filter-navigation-item')
        items.forEach((item) => {
            item.classList.remove('js__filter--is-active')
        })
    }

    /**
     * activateResetButtonStyle
     * @returns {undefined}
     */
    activateResetButtonStyle() {
        document.querySelector('.js__download__filter-navigation-item--reset').classList.add('js__reset-is-active')
    }

    /**
     * deactivateResetButtonStyle
     * @returns {undefined}
     */
    deactivateResetButtonStyle() {
        document.querySelector('.js__download__filter-navigation-item--reset').classList.remove('js__reset-is-active')
    }
}
